import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { BotsCreators } from '../../../store/actions/bots';
import { CompanyActions } from '../../../store/actions/companies';
import { ItemsCreators } from '../../../store/actions/items';
import { UserActions } from '../../../store/actions/users';
import { TriggerActions } from '../../../store/actions/triggers';

import actions from '../../../store/actions';

import './index.scss';

import SettingsGeneral from '../../../components/Builder/SettingsTab/SettingsGeneral';
import SettingsContentEmail from '../../../components/Builder/SettingsTab/SettingsContentEmail';
import SettingsContentSMS from '../../../components/Builder/SettingsTab/SettingsContentSMS';
import SettingsContentStorage from '../../../components/Builder/SettingsTab/SettingsContentStorage';
import SettingsContentHuman from '../../../components/Builder/SettingsTab/SettingsContentHuman';
import SettingsContentIA from '../../../components/Builder/SettingsTab/SettingsContentIA';
import SettingsZendeskRequest from '../../../components/Builder/SettingsTab/SettingsZendeskRequest';
import SettingsJira from '../../../components/Builder/SettingsTab/SettingsJira';
import SettingsGlpi from '../../../components/Builder/SettingsTab/SettingsGlpi';
import SettingsEscape from '../../../components/Builder/SettingsTab/SettingsEscape';
import SettingsAttendanceHours from '../../../components/Builder/SettingsTab/SettingsAttendanceHours/SettingsAttendanceHours';
import SettingsQuickAccess from '../../../components/Builder/SettingsTab/SettingsQuickAccess/SettingsQuickAccess';
import SettingsRDStation from '../../../components/Builder/SettingsTab/SettingsRDStation';
import Footer from '../../../components/Footer2';

class SettingsTab extends Component {
  state = {
    menuItem: 'geral',
    tab: 'geral',
  };

  componentDidMount() {
    const {
      retrieveBotRequest,
      match,
      load,
      listItemsRequest,
      getAllItems,
      companies,
      getCompanies,
    } = this.props;
    const { botid } = match.params;
    retrieveBotRequest(botid);
    load(botid);
    listItemsRequest(botid);
    getAllItems({ botId: botid });

    if (!Array.isArray(companies) || companies.length === 0) {
      getCompanies('');
    }
  }

  updateMenuItems = (item, tab) => {
    this.setState({ menuItem: item, tab });
  };

  render() {
    const { i18n, bot } = this.props;

    const { menuItem, tab } = this.state;

    return (
      <div className="row linha-conteudo">
        <div className="col-md-12 conteudo-iniciar">
          <div className="settings-tab">
            <div className="settings-tab-menu" style={{ paddingBottom: 20 }}>
              <div
                className={
                  tab === 'geral'
                    ? 'settings-tab-menu-title'
                    : 'settings-tab-menu-items'
                }
              >
                <span
                  onClick={() => this.updateMenuItems('geral', 'geral')}
                  style={{ cursor: 'pointer' }}
                >
                  {i18n.t('Geral')}
                </span>
              </div>
              <div className="line-config" />
              <div
                className={
                  tab == 'criador'
                    ? 'settings-tab-menu-title'
                    : 'settings-tab-menu-items'
                }
              >
                {i18n.t('Criador')}
              </div>
              <div className="settings-tab-menu-items">
                <div className={menuItem === 'email' ? 'active' : ''}>
                  <div className="dot" />
                  <span
                    onClick={() => this.updateMenuItems('email', 'criador')}
                  >
                    {i18n.t('Email (SMTP)')}
                  </span>
                </div>
                <div className={menuItem === 'sms' ? 'active' : ''}>
                  <div className="dot" />
                  <span onClick={() => this.updateMenuItems('sms', 'criador')}>
                    {i18n.t('SMS')}
                  </span>
                </div>
                <div className={menuItem === 'storage' ? 'active' : ''}>
                  <div className="dot" />
                  <span
                    onClick={() => this.updateMenuItems('storage', 'criador')}
                  >
                    {i18n.t('Armazenamento')}
                  </span>
                </div>
                <div className={menuItem === 'human' ? 'active' : ''}>
                  <div className="dot" />
                  <span
                    onClick={() => this.updateMenuItems('human', 'criador')}
                  >
                    {i18n.t('Atendimento Humano')}
                  </span>
                </div>
                <div className={menuItem === 'ia' ? 'active' : ''}>
                  <div className="dot" />
                  <span onClick={() => this.updateMenuItems('ia', 'criador')}>
                    {i18n.t('Inteligência Artificial')}
                  </span>
                </div>
                <div className={menuItem === 'escape' ? 'active' : ''}>
                  <div className="dot" />
                  <span
                    onClick={() => this.updateMenuItems('escape', 'criador')}
                  >
                    {i18n.t('Rota de Fuga')}
                  </span>
                </div>
                <div className={menuItem === 'timezone' ? 'active' : ''}>
                  <div className="dot" />
                  <span
                    onClick={() => this.updateMenuItems('timezone', 'criador')}
                  >
                    {i18n.t('Horário de atendimento')}
                  </span>
                </div>
                <div className={menuItem === 'quickAccess' ? 'active' : ''}>
                  <div className="dot" />
                  <span
                    onClick={() =>
                      this.updateMenuItems('quickAccess', 'criador')
                    }
                  >
                    {i18n.t('Acesso Rápido')}
                  </span>
                </div>
              </div>
              <div className="line-config" />
              <div
                className={
                  tab == 'integracoes'
                    ? 'settings-tab-menu-title'
                    : 'settings-tab-menu-items'
                }
              >
                {i18n.t('Integrações')}
              </div>
              <div className="settings-tab-menu-items">
                <div className={menuItem === 'zendeskRequest' ? 'active' : ''}>
                  <div className="dot" />
                  <span
                    onClick={() =>
                      this.updateMenuItems('zendeskRequest', 'integracoes')
                    }
                  >
                    {i18n.t('Zendesk')}
                  </span>
                </div>
              </div>
              <div className="settings-tab-menu-items">
                <div className={menuItem === 'jiraSettings' ? 'active' : ''}>
                  <div className="dot" />
                  <span
                    onClick={() =>
                      this.updateMenuItems('jiraSettings', 'integracoes')
                    }
                  >
                    {i18n.t('Jira')}
                  </span>
                </div>
              </div>
              <div className="settings-tab-menu-items">
                <div className={menuItem === 'rdStation' ? 'active' : ''}>
                  <div className="dot" />
                  <span
                    onClick={() =>
                      this.updateMenuItems('rdStation', 'integracoes')
                    }
                  >
                    {i18n.t('RD Station')}
                  </span>
                </div>
              </div>
              <div className="settings-tab-menu-items">
                <div className={menuItem === 'glpiSettings' ? 'active' : ''}>
                  <div className="dot" />
                  <span
                    onClick={() =>
                      this.updateMenuItems('glpiSettings', 'integracoes')
                    }
                  >
                    {i18n.t('GLPi')}
                  </span>
                </div>
              </div>
            </div>
            <div
              className={
                tab === 'geral'
                  ? 'settings-tab-content widh-geral'
                  : (menuItem === 'human' ? 'settings-tab-content human-tab-container' : 'settings-tab-content')
              }
            >
              {menuItem === 'geral' && bot && bot._id && (
                <SettingsGeneral {...this.props} />
              )}
              {menuItem === 'email' && bot && bot._id && (
                <SettingsContentEmail {...this.props} />
              )}
              {menuItem === 'sms' && bot && bot._id && (
                <SettingsContentSMS {...this.props} />
              )}
              {menuItem === 'storage' && bot && bot._id && (
                <SettingsContentStorage {...this.props} />
              )}
              {menuItem === 'human' && bot && bot._id && (
                <SettingsContentHuman {...this.props} />
              )}
              {menuItem === 'ia' && bot && bot._id && (
                <SettingsContentIA {...this.props} />
              )}
              {menuItem === 'zendeskRequest' && bot && bot._id && (
                <SettingsZendeskRequest {...this.props} />
              )}
              {menuItem === 'jiraSettings' && bot && bot._id && (
                <SettingsJira {...this.props} />
              )}
              {menuItem === 'glpiSettings' && bot && bot._id && (
                <SettingsGlpi {...this.props} />
              )}
              {menuItem === 'escape' && bot && bot._id && (
                <SettingsEscape {...this.props} />
              )}
              {menuItem === 'timezone' && bot && bot._id && (
                <SettingsAttendanceHours {...this.props} />
              )}
              {menuItem === 'quickAccess' && bot && bot._id && (
                <SettingsQuickAccess {...this.props} />
              )}
              {menuItem === 'rdStation' && bot && bot._id && (
                <SettingsRDStation {...this.props} />
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  companies: state.companies?.companies,
  bot: state.bots.bot,
  user: state.users.signedUser,
  item: state.items,
  trigger: state.triggers,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...BotsCreators,
      ...UserActions,
      ...ItemsCreators,
      ...TriggerActions,
      ...CompanyActions,
      ...actions.previewBot,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SettingsTab))
);
